import {
    CALL_API
} from 'redux-api-middleware';
import {getUrlQuery} from '../utils/url';

function getExternalQueryString(queryData){
  if(queryData){
    return  `&${getUrlQuery(queryData)}`;
  }
  return '';
}
export function submitElement(url = '', values, type) {
    return {
        [CALL_API]: {
            endpoint: url + (values.id ? '/' + values.id : ''),
            method: values.id ? 'PUT' : 'POST',
            body: values,
            types: type.all
        }
    };
}

export function deleteElement(url = '', id, type) {
    return {
        [CALL_API]: {
            endpoint: `${url}/${id}`,
            method:'DELETE',
            types: type.all
        }
    };
}

export function fetchElement(url = '', itemId, type) {
    if (itemId === 'new') {
        return {
            type: type.SUCCESS,
            payload: {}
        }
    } else {
        return {
            [CALL_API]: {
                endpoint: `${url}/${itemId}`,
                method: 'GET',
                types: type.all
            }
        };
    }
}

export function fetchElementsPaginated(url = '', page, size, type, queryData) {
    return {
        [CALL_API]: {
            endpoint: `${url}?page=${page}&size=${size}${getExternalQueryString(queryData)}`,
            method: 'GET',
            types: [{
                    type: type.REQUEST,
                    meta: {
                        page,
                        size
                    }
                },
                type.SUCCESS,
                type.FAILURE
            ]
        }
    };
}



// WEBPACK FOOTER //
// ./src/js/actions/common.js